import type { FCC } from '../../types';

export const SummaryGrid: FCC = ({ children }) => {
    return <div className={'grid grid-cols-2 gap-x-2 sm:gap-x-12'}> {children} </div>;
};